/* The Sleep Co — homepage interactions. Guarded so it runs once even if
   the script tag is included by several sections. */
(function () {
  if (window.__tscInit) return;
  window.__tscInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Sticky header shadow
    var header = document.querySelector('.tsc-header');
    if (header) {
      var onScroll = function () { header.classList.toggle('stuck', window.scrollY > 8); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Search panel
    var panel = document.querySelector('.tsc-search');
    var openBtn = document.querySelector('[data-tsc-search]');
    var closeBtn = document.querySelector('[data-tsc-search-close]');
    var toggle = function (open) {
      if (!panel) return;
      panel.classList.toggle('open', open);
      if (open) { var i = panel.querySelector('input'); if (i) setTimeout(function () { i.focus(); }, 120); }
    };
    if (openBtn) openBtn.addEventListener('click', function () { toggle(!panel.classList.contains('open')); });
    if (closeBtn) closeBtn.addEventListener('click', function () { toggle(false); });

    // Mobile drawer
    var drawer = document.querySelector('.tsc-drawer');
    var burger = document.querySelector('[data-tsc-burger]');
    if (burger && drawer) {
      burger.addEventListener('click', function () { drawer.classList.add('open'); });
      drawer.addEventListener('click', function (e) {
        if (e.target.matches('.scrim, .close') || e.target.closest('.panel a')) drawer.classList.remove('open');
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { toggle(false); if (drawer) drawer.classList.remove('open'); }
    });

    // Reveal on scroll
    var els = document.querySelectorAll('.tsc .reveal:not(.in)');
    if ('IntersectionObserver' in window && els.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('in'); });
    }
  });
})();
